<template>
  <el-form class="form form__login" ref="form" :model="logInForm" :rules="rules" @submit.native.prevent="onSubmit()">

    <messages :request="request" :errorMessages="errorMessages"></messages>

    <input-email-field id="email" :disabled="!isOnline" v-model="logInForm.email" @input="setUserId" />

    <input-password-field id="password" :disabled="!isOnline" v-model="logInForm.password">
      <template v-slot:accessory>
        <router-link :to="{ name: 'ForgotPassword' }">
          {{ $t('authenticationForgotPasswordAccessory') }}
        </router-link>
      </template>
    </input-password-field>

    <input-language-dropdown id="language" :disabled="!isOnline" :value="logInForm.language"
      @change="setLocalLanguage" />

    <div class="card__footer">
      <div class="card__footer_button_wrap">
        <el-button type="primary" native-type="submit" :disabled="!isOnline">
          {{ $t('applicationLogin') }}
        </el-button>
      </div>
      <p class="card__footer_footnote">
        <span>{{ $t('applicationDontHaveAccount') }}</span>
        <router-link class="card__footer_link" :to="{ name: 'SignUp' }">
          {{ $t('applicationSignUp') }}
        </router-link>
      </p>
    </div>

  </el-form>
</template>

<script>
import authentication from '@/authentication';
import i18n from '@/configured/vue-i18n';
import { mapActions, mapGetters, mapState } from 'vuex';
import Messages from '@/components/Messages'
import validations from './inputs/validations';
import InputEmailField from './inputs/InputEmailField.vue';
import InputPasswordField from './inputs/InputPasswordField.vue';
import InputLanguageDropdown from './inputs/InputLanguageDropdown.vue';
import offline from '@/offline';
import log from '@/configured/logger';

export default {
  name: 'LogInForm',
  data() {
    return {
      request: null,
      logInForm: {
        email: '',
        password: '',
        language: this.$store.state[i18n.store.namespace].language || 'en',
      },
      rules: {
        email: [
          {
            required: true,
            message: i18n.i18n.t('authenticationEmailRequired'),
          },
          ...validations.rules().email,
        ],
        password: [
          {
            required: true,
            message: i18n.i18n.t('authenticationPasswordRequired'),
          },
          ...validations.rules().password,
        ],
      },
      errorMessages: {
        invalid_credentials: i18n.i18n.t('authenticationInvalidCredentials'),
        pending_verification: i18n.i18n.t('authenticationPendingVerification'),
        account_locked: i18n.i18n.t('autheticationAccountLocked'),
        account_cooldown: i18n.i18n.t('autheticationAccountCooldown'),
        account_suspended: i18n.i18n.t('autheticationAccountSuspended'),
        password_reset_required: i18n.i18n.t('autheticationPasswordReset'),
      }
    }
  },
  computed: {
    ...mapState(offline.store.namespace, [
      'isOnline'
    ])
  },
  methods: {
    ...mapActions(authentication.store.namespace, [
      'logIn',
      'setUserId'
    ]),
    onSubmit() {
      this.request = this.logIn(this.logInForm.password)
    },
    setLocalLanguage(language) {
      this.logInForm.language = language;
      i18n.loadLanguageAsync(language);
    }
  },
  components: {
    InputEmailField,
    InputPasswordField,
    InputLanguageDropdown,
    Messages
  }
}
</script>
